import { httpRequest } from "../../http";
import { CatalogCoreFieldSample } from "@models/catalog.model";

// Per-vertical doc-copy (sample + description) for core key/contact fields (MPN-1233). Read-only
// here — the editor displays them; authoring lives on the Tracked Metric Catalog page.
export class CommandListCoreFieldSamples {
  async run(verticalCode: string): Promise<CatalogCoreFieldSample[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${encodeURIComponent(verticalCode)}/core-field-samples/`;
    return httpRequest<CatalogCoreFieldSample[]>(url, { method: "GET" });
  }
}
